/**
 * External dependencies
 */
import "@micropackage/vw/src/js/vw.js";
import objectFitImages from "object-fit-images";
import responsiveEmbeds from "@micropackage/responsive-embeds";
import GiftCardPopup from "./sections/gift-card-popup";

/**
 * Internal Dependencies
 */
import "./utils/placeholder-shown-polyfill";
import WelcomePopUp from "./components/welcome-pop-up";
import ImagePopUp from "./components/pop-up";
import Header from "./sections/header";
import Menu from "./sections/menu";
import RegistrationForm from "./blocks/registration-form";
import LocationsNav from "./blocks/locations-nav";
import blockFactory from "./utils/block-factory";
import ScrollManager from "./utils/scroll-manager";

objectFitImages();
responsiveEmbeds('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]');

const giftCardPopup = new GiftCardPopup();

window.recaptchaOnloadCallback = () => {
	giftCardPopup.initReCaptcha();
};

blockFactory("registration-form", RegistrationForm);
blockFactory("locations", LocationsNav);

new WelcomePopUp();
new ImagePopUp();
new Header();
new Menu();
new ScrollManager();
